export const DEFAULT_TDM_DATA = { TOPICS: [], contentQuality: { CURRENT: {}, PROJECTED: {} }, contentQualityRaw: {} };

export const PLACE_HOLDER_FOR_TOPICS_5_COMP = [
  {
    name: 'https://www.quattr.com/about-us',
    logo: 'https://www.google.com/s2/favicons?domain=https://www.quattr.com/about-us',
    score: 185,
    isCustomer: false,
    market_share: null,
    showRadio: false,
  },
  {
    name: 'https://www.quattr.com/ai-seo-tools',
    logo: 'https://www.google.com/s2/favicons?domain=https://www.quattr.com/ai-seo-tools',
    score: 180,
    isCustomer: false,
    market_share: null,
    showRadio: false,
  },
  {
    name: 'https://www.quattr.com/free-tools/title-generator',
    logo: 'https://www.google.com/s2/favicons?domain=https://www.quattr.com/free-tools/title-generator',
    score: 172,
    isCustomer: false,
    market_share: null,
    showRadio: false,
  },
  {
    name: 'https://www.quattr.com/free-tools/heading-generator',
    logo: 'https://www.google.com/s2/favicons?domain=https://www.quattr.com/free-tools/heading-generator',
    score: 169,
    isCustomer: false,
    market_share: null,
    showRadio: false,
  },
  {
    name: 'https://www.quattr.com/free-tools/meta-description-generator',
    logo: 'https://www.google.com/s2/favicons?domain=https://www.quattr.com/free-tools/meta-description-generator',
    score: 16,
    isCustomer: false,
    market_share: null,
    showRadio: false,
  },
];

export const PLACE_HOLDER_TOPIC_DATA = [
  {
    'Topic Importance': 100,
    'Competitor Prevalence': '2 of 34',
    Topic: 'Search Engine Optimization Made Easy',
    'Topic Id': '03acf839-13c8-5059-849b-28e431b55a37',
    Quattr: 0,
    Customer: 0,
    Competitors: '1 - 7',
    'Headings count': '2 Headings',
    Logourls: ['https://moz.com/beginners-guide-to-seo', 'https://seositecheckup.com/'],
    expandedViewData: {
      improveHeadingData: [
        {
          name: 'The basics of search engine optimization',
          url: 'https://moz.com/beginners-guide-to-seo',
          flag: 0,
          html_tag: 'H2',
          html_id: 6505021665864126,
          num_sents: 7,
          isCustomer: false,
        },
        {
          name: 'Search Engine Optimization Made Easy',
          url: 'https://seositecheckup.com/',
          flag: 0,
          html_tag: 'H1',
          html_id: 8896750449371315,
          num_sents: 1,
          isCustomer: false,
        },
      ],
      keywords: [
        {
          KEYWORD: ' seo optimization',
          KEYWORD_IMPORTANCE: 5,
          KEYWORD_RELEVANCE: 0.59,
          keyword_emphasis_projected: null,
          keyword_emphasis: 59,
          current_emphasis_rank: '>4',
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: 'google search console',
          KEYWORD_IMPORTANCE: 32,
          KEYWORD_RELEVANCE: 0.49,
          keyword_emphasis_projected: null,
          keyword_emphasis: 78,
          current_emphasis_rank: 1,
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo tools',
          KEYWORD_IMPORTANCE: 3,
          KEYWORD_RELEVANCE: 0.42,
          keyword_emphasis_projected: null,
          keyword_emphasis: 66,
          current_emphasis_rank: '>4',
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo checklist',
          KEYWORD_IMPORTANCE: 2,
          KEYWORD_RELEVANCE: 0.4,
          keyword_emphasis_projected: null,
          keyword_emphasis: 60,
          current_emphasis_rank: '>4',
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo analysis',
          KEYWORD_IMPORTANCE: 1,
          KEYWORD_RELEVANCE: 0.39,
          keyword_emphasis_projected: null,
          keyword_emphasis: 61,
          current_emphasis_rank: 3,
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo strategies',
          KEYWORD_IMPORTANCE: 1,
          KEYWORD_RELEVANCE: 0.38,
          keyword_emphasis_projected: null,
          keyword_emphasis: 58,
          current_emphasis_rank: 4,
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
      ],
    },
    htmlContent: {
      customerHtmlContent: [],
      competitorHtmlContent: [
        {
          name: 'The basics of search engine optimization',
          url: 'https://moz.com/beginners-guide-to-seo',
          flag: 0,
          html_tag: 'H2',
          html_id: 6505021665864126,
          num_sents: 7,
          isCustomer: false,
        },
        {
          name: 'Search Engine Optimization Made Easy',
          url: 'https://seositecheckup.com/',
          flag: 0,
          html_tag: 'H1',
          html_id: 8896750449371315,
          num_sents: 1,
          isCustomer: false,
        },
      ],
    },
    updatedInfo: {
      isEdited: false,
      isSuggested: false,
      updated_by: '',
      updated_on: '',
      created_on: '',
    },
  },
  {
    'Topic Importance': 93,
    'Competitor Prevalence': '1 of 34',
    Topic: 'How to do SEO: Technical optimizations',
    'Topic Id': 'aa6a3eaa-710d-5419-b12d-99f864865384',
    Quattr: 0,
    Customer: 0,
    Competitors: 11,
    'Headings count': '2 Headings',
    Logourls: ['https://www.quattr.com/free-tools/title-generator'],
    expandedViewData: {
      improveHeadingData: [
        {
          name: 'How to do SEO: Technical optimizations',
          url: 'https://www.quattr.com/free-tools/title-generator',
          flag: 0,
          html_tag: 'H2',
          html_id: 7423313606624205,
          num_sents: 10,
          isCustomer: false,
        },
        {
          name: 'Search Engine Optimization – Learn to Optimize for SEO',
          url: 'https://www.quattr.com/free-tools/title-generator',
          flag: 0,
          html_tag: 'H1',
          html_id: 3176431165909401,
          num_sents: 1,
          isCustomer: false,
        },
      ],
      keywords: [
        {
          KEYWORD: ' seo optimization',
          KEYWORD_IMPORTANCE: 5,
          KEYWORD_RELEVANCE: 0.84,
          keyword_emphasis_projected: null,
          keyword_emphasis: 59,
          current_emphasis_rank: '>4',
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo strategies',
          KEYWORD_IMPORTANCE: 1,
          KEYWORD_RELEVANCE: 0.6,
          keyword_emphasis_projected: null,
          keyword_emphasis: 58,
          current_emphasis_rank: 4,
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo tools',
          KEYWORD_IMPORTANCE: 3,
          KEYWORD_RELEVANCE: 0.57,
          keyword_emphasis_projected: null,
          keyword_emphasis: 66,
          current_emphasis_rank: '>4',
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo checklist',
          KEYWORD_IMPORTANCE: 2,
          KEYWORD_RELEVANCE: 0.55,
          keyword_emphasis_projected: null,
          keyword_emphasis: 60,
          current_emphasis_rank: '>4',
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo analysis',
          KEYWORD_IMPORTANCE: 1,
          KEYWORD_RELEVANCE: 0.55,
          keyword_emphasis_projected: null,
          keyword_emphasis: 61,
          current_emphasis_rank: 3,
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: 'google search console',
          KEYWORD_IMPORTANCE: 32,
          KEYWORD_RELEVANCE: 0.34,
          keyword_emphasis_projected: null,
          keyword_emphasis: 78,
          current_emphasis_rank: 1,
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
      ],
    },
    htmlContent: {
      customerHtmlContent: [],
      competitorHtmlContent: [
        {
          name: 'How to do SEO: Technical optimizations',
          url: 'https://www.quattr.com/free-tools/title-generator',
          flag: 0,
          html_tag: 'H2',
          html_id: 7423313606624205,
          num_sents: 10,
          isCustomer: false,
        },
        {
          name: 'Search Engine Optimization – Learn to Optimize for SEO',
          url: 'https://www.quattr.com/free-tools/title-generator',
          flag: 0,
          html_tag: 'H1',
          html_id: 3176431165909401,
          num_sents: 1,
          isCustomer: false,
        },
      ],
    },
    updatedInfo: {
      isEdited: false,
      isSuggested: false,
      updated_by: '',
      updated_on: '',
      created_on: '',
    },
  },
  {
    'Topic Importance': 92,
    'Competitor Prevalence': '0 of 34',
    Topic: "How can I improve my website's search performance using Search Console data?",
    'Topic Id': 'bd076f4f-2684-51d0-be3d-1edd8fe01505',
    Quattr: 3,
    Customer: 3,
    'Headings count': '1 Headings',
    Logourls: ['https://www.quattr.com/search-console/gsc-beginners-guide?'],
    expandedViewData: {
      improveHeadingData: [
        {
          name: "How can I improve my website's search performance using Search Console data?",
          url: 'https://www.quattr.com/search-console/gsc-beginners-guide?',
          flag: 1,
          html_tag: 'H4',
          html_id: 4956725122280477,
          num_sents: 3,
          isCustomer: true,
          updatedInfo: {
            isSuggested: false,
            updated_on: null,
            updated_by: null,
            isEdited: false,
          },
        },
      ],
      keywords: [
        {
          KEYWORD: 'google search console',
          KEYWORD_IMPORTANCE: 32,
          KEYWORD_RELEVANCE: 0.76,
          keyword_emphasis_projected: null,
          keyword_emphasis: 78,
          current_emphasis_rank: 1,
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo tools',
          KEYWORD_IMPORTANCE: 3,
          KEYWORD_RELEVANCE: 0.34,
          keyword_emphasis_projected: null,
          keyword_emphasis: 66,
          current_emphasis_rank: '>4',
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo checklist',
          KEYWORD_IMPORTANCE: 2,
          KEYWORD_RELEVANCE: 0.34,
          keyword_emphasis_projected: null,
          keyword_emphasis: 60,
          current_emphasis_rank: '>4',
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo optimization',
          KEYWORD_IMPORTANCE: 5,
          KEYWORD_RELEVANCE: 0.31,
          keyword_emphasis_projected: null,
          keyword_emphasis: 59,
          current_emphasis_rank: '>4',
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo analysis',
          KEYWORD_IMPORTANCE: 1,
          KEYWORD_RELEVANCE: 0.3,
          keyword_emphasis_projected: null,
          keyword_emphasis: 61,
          current_emphasis_rank: 3,
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo strategies',
          KEYWORD_IMPORTANCE: 1,
          KEYWORD_RELEVANCE: 0.28,
          keyword_emphasis_projected: null,
          keyword_emphasis: 58,
          current_emphasis_rank: 4,
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
      ],
    },
    htmlContent: {
      customerHtmlContent: [
        {
          name: "How can I improve my website's search performance using Search Console data?",
          url: 'https://www.quattr.com/search-console/gsc-beginners-guide?',
          flag: 1,
          html_tag: 'H4',
          html_id: 4956725122280477,
          num_sents: 3,
          isCustomer: true,
          updatedInfo: {
            isSuggested: false,
            updated_on: null,
            updated_by: null,
            isEdited: false,
          },
        },
      ],
      competitorHtmlContent: [],
    },
    updatedInfo: {
      isEdited: false,
      isSuggested: false,
      updated_by: '',
      updated_on: '',
      created_on: '',
    },
  },
  {
    'Topic Importance': 90,
    'Competitor Prevalence': '1 of 34',
    Topic: 'Step #6: Optimize For Search Intent',
    'Topic Id': '985da555-e144-5d33-90a6-159c96609cdd',
    Quattr: 0,
    Customer: 0,
    Competitors: 21,
    'Headings count': '1 Headings',
    Logourls: ['https://backlinko.com/seo-strategy'],
    expandedViewData: {
      improveHeadingData: [
        {
          name: 'Step #6: Optimize For Search Intent',
          url: 'https://backlinko.com/seo-strategy',
          flag: 0,
          html_tag: 'H2',
          html_id: 871577222519209,
          num_sents: 21,
          isCustomer: false,
        },
      ],
      keywords: [
        {
          KEYWORD: ' seo optimization',
          KEYWORD_IMPORTANCE: 5,
          KEYWORD_RELEVANCE: 0.48,
          keyword_emphasis_projected: null,
          keyword_emphasis: 59,
          current_emphasis_rank: '>4',
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: 'google search console',
          KEYWORD_IMPORTANCE: 32,
          KEYWORD_RELEVANCE: 0.43,
          keyword_emphasis_projected: null,
          keyword_emphasis: 78,
          current_emphasis_rank: 1,
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo tools',
          KEYWORD_IMPORTANCE: 3,
          KEYWORD_RELEVANCE: 0.33,
          keyword_emphasis_projected: null,
          keyword_emphasis: 66,
          current_emphasis_rank: '>4',
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo checklist',
          KEYWORD_IMPORTANCE: 2,
          KEYWORD_RELEVANCE: 0.32,
          keyword_emphasis_projected: null,
          keyword_emphasis: 60,
          current_emphasis_rank: '>4',
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo analysis',
          KEYWORD_IMPORTANCE: 1,
          KEYWORD_RELEVANCE: 0.32,
          keyword_emphasis_projected: null,
          keyword_emphasis: 61,
          current_emphasis_rank: 3,
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo strategies',
          KEYWORD_IMPORTANCE: 1,
          KEYWORD_RELEVANCE: 0.3,
          keyword_emphasis_projected: null,
          keyword_emphasis: 58,
          current_emphasis_rank: 4,
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
      ],
    },
    htmlContent: {
      customerHtmlContent: [],
      competitorHtmlContent: [
        {
          name: 'Step #6: Optimize For Search Intent',
          url: 'https://backlinko.com/seo-strategy',
          flag: 0,
          html_tag: 'H2',
          html_id: 871577222519209,
          num_sents: 21,
          isCustomer: false,
        },
      ],
    },
    updatedInfo: {
      isEdited: false,
      isSuggested: false,
      updated_by: '',
      updated_on: '',
      created_on: '',
    },
  },
  {
    'Topic Importance': 87,
    'Competitor Prevalence': '1 of 34',
    Topic: 'Rankings and traffic through search engine optimization',
    'Topic Id': '1d8d4443-7634-5713-829c-c97c9e119ecf',
    Quattr: 0,
    Customer: 0,
    Competitors: 1,
    'Headings count': '1 Headings',
    Logourls: ['https://moz.com/beginners-guide-to-seo'],
    expandedViewData: {
      improveHeadingData: [
        {
          name: 'Rankings and traffic through search engine optimization',
          url: 'https://moz.com/beginners-guide-to-seo',
          flag: 0,
          html_tag: 'H4',
          html_id: 3523182768258477,
          num_sents: 1,
          isCustomer: false,
        },
      ],
      keywords: [
        {
          KEYWORD: ' seo optimization',
          KEYWORD_IMPORTANCE: 5,
          KEYWORD_RELEVANCE: 0.61,
          keyword_emphasis_projected: null,
          keyword_emphasis: 59,
          current_emphasis_rank: '>4',
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo strategies',
          KEYWORD_IMPORTANCE: 1,
          KEYWORD_RELEVANCE: 0.42,
          keyword_emphasis_projected: null,
          keyword_emphasis: 58,
          current_emphasis_rank: 4,
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo analysis',
          KEYWORD_IMPORTANCE: 1,
          KEYWORD_RELEVANCE: 0.42,
          keyword_emphasis_projected: null,
          keyword_emphasis: 61,
          current_emphasis_rank: 3,
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo tools',
          KEYWORD_IMPORTANCE: 3,
          KEYWORD_RELEVANCE: 0.41,
          keyword_emphasis_projected: null,
          keyword_emphasis: 66,
          current_emphasis_rank: '>4',
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo checklist',
          KEYWORD_IMPORTANCE: 2,
          KEYWORD_RELEVANCE: 0.41,
          keyword_emphasis_projected: null,
          keyword_emphasis: 60,
          current_emphasis_rank: '>4',
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: 'google search console',
          KEYWORD_IMPORTANCE: 32,
          KEYWORD_RELEVANCE: 0.4,
          keyword_emphasis_projected: null,
          keyword_emphasis: 78,
          current_emphasis_rank: 1,
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
      ],
    },
    htmlContent: {
      customerHtmlContent: [],
      competitorHtmlContent: [
        {
          name: 'Rankings and traffic through search engine optimization',
          url: 'https://moz.com/beginners-guide-to-seo',
          flag: 0,
          html_tag: 'H4',
          html_id: 3523182768258477,
          num_sents: 1,
          isCustomer: false,
        },
      ],
    },
    updatedInfo: {
      isEdited: false,
      isSuggested: false,
      updated_by: '',
      updated_on: '',
      created_on: '',
    },
  },
  {
    'Topic Importance': 87,
    'Competitor Prevalence': '1 of 34',
    Topic: 'Create Search Engine Optimized Content',
    'Topic Id': '6cb99fd0-eb0e-5bd7-b029-7d11ba9779c4',
    Quattr: 0,
    Customer: 0,
    Competitors: 42,
    'Headings count': '1 Headings',
    Logourls: ['https://www.quattr.com/about-us'],
    expandedViewData: {
      improveHeadingData: [
        {
          name: '6. Create Search Engine Optimized Content',
          url: 'https://www.quattr.com/about-us',
          flag: 0,
          html_tag: 'H3',
          html_id: 6064866783801894,
          num_sents: 42,
          isCustomer: false,
        },
      ],
      keywords: [
        {
          KEYWORD: ' seo optimization',
          KEYWORD_IMPORTANCE: 5,
          KEYWORD_RELEVANCE: 0.51,
          keyword_emphasis_projected: null,
          keyword_emphasis: 59,
          current_emphasis_rank: '>4',
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: 'google search console',
          KEYWORD_IMPORTANCE: 32,
          KEYWORD_RELEVANCE: 0.41,
          keyword_emphasis_projected: null,
          keyword_emphasis: 78,
          current_emphasis_rank: 1,
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo tools',
          KEYWORD_IMPORTANCE: 3,
          KEYWORD_RELEVANCE: 0.4,
          keyword_emphasis_projected: null,
          keyword_emphasis: 66,
          current_emphasis_rank: '>4',
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo checklist',
          KEYWORD_IMPORTANCE: 2,
          KEYWORD_RELEVANCE: 0.37,
          keyword_emphasis_projected: null,
          keyword_emphasis: 60,
          current_emphasis_rank: '>4',
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo strategies',
          KEYWORD_IMPORTANCE: 1,
          KEYWORD_RELEVANCE: 0.35,
          keyword_emphasis_projected: null,
          keyword_emphasis: 58,
          current_emphasis_rank: 4,
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
        {
          KEYWORD: ' seo analysis',
          KEYWORD_IMPORTANCE: 1,
          KEYWORD_RELEVANCE: 0.34,
          keyword_emphasis_projected: null,
          keyword_emphasis: 61,
          current_emphasis_rank: 3,
          projected_emphasis_rank: null,
          average_position: 0,
          monthly_clicks: 0,
          ctr: 0,
        },
      ],
    },
    htmlContent: {
      customerHtmlContent: [],
      competitorHtmlContent: [
        {
          name: '6. Create Search Engine Optimized Content',
          url: 'https://www.quattr.com/about-us',
          flag: 0,
          html_tag: 'H3',
          html_id: 6064866783801894,
          num_sents: 42,
          isCustomer: false,
        },
      ],
    },
    updatedInfo: {
      isEdited: false,
      isSuggested: false,
      updated_by: '',
      updated_on: '',
      created_on: '',
    },
  },
];
